function Services() {
  return (
    <section id="services" className="services-section">
      <h2>Layanan Kami</h2>
      <p>Jelajahi layanan digital MomenQ untuk mengabadikan setiap momen spesialmu.</p>

      <div className="services-container">
        {/* Virtual Photobooth */}
        <div className="service-card">
          <img src="/photobooth.png" alt="Virtual Photobooth" />
          <h3>Virtual Photobooth</h3>
          <p>Cara mudah bagi tamu untuk menikmati photobooth menggunakan ponsel mereka sendiri.</p>
          <a href="#virtual-photobooth" className="cta-button">Pelajari</a>
        </div>

        {/* E-Invitation */}
        <div className="service-card coming-soon">
          <img src="/logo.png" alt="E-Invitation" />
          <h3>E-Invitation</h3>
          <p>Kirim undangan digital elegan untuk tamu undanganmu (Segera hadir).</p>
          <span className="coming-soon-label">Coming Soon</span>
        </div>

        {/* Guest Book */}
        <div className="service-card coming-soon">
          <img src="/logo.png" alt="Guest Book" />
          <h3>Guest Book</h3>
          <p>Catat pesan dan kenangan dari tamu undangan secara digital (Segera hadir).</p>
          <span className="coming-soon-label">Coming Soon</span>
        </div>
      </div>
    </section>
  );
}

export default Services;
